import React from "react";
import { Link } from "react-router-dom";
import "./DataDeletion.css";

const DataDeletion = () => {
  return (
    <div className="deletion-container">
      <div className="deletion-content">
        <Link to="/" className="back-button">
          <i className="fas fa-arrow-left"></i> 返回首頁
        </Link>

        <div className="deletion-header">
          <h1>
            <span role="img" aria-label="trash">
              🗑️
            </span>{" "}
            使用者資料刪除說明
          </h1>
        </div>

        <div className="deletion-body">
          <p>
            若您希望刪除透過 Facebook
            登入所建立的帳號及相關資料，請依下列方式申請：
          </p>

          <div className="deletion-steps">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>請聯絡管理員</h3>
                <p>
                  並於訊息中提供您使用 Facebook 登入時的姓名與電子郵件地址。
                </p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>處理時間</h3>
                <p>我們將於 7 個工作天內完成資料刪除並回覆通知。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
